__turbopack_context__.v({
  "htmlContainer": "DelegationHTML-module-scss-module__ibSifG__htmlContainer",
  "pageNotFound": "DelegationHTML-module-scss-module__ibSifG__pageNotFound",
});
